import { Entity } from '@backstage/catalog-model';
import { TemplateEntityV1beta3 } from '@backstage/plugin-scaffolder-common';

export const extractTemplateValues = (entity: Entity) => {
  const template = entity as TemplateEntityV1beta3;

  const parameterDefaults: Record<string, unknown> = {};
  const requiredFields = new Set<string>();
  const hiddenFields = new Set<string>();

  // Extract default values and required fields from the template parameters
  if (Array.isArray(template.spec?.parameters)) {
    template.spec.parameters.forEach(section => {
      const properties = section.properties ?? {};

      if (Array.isArray(section.required)) {
        section.required.forEach(field => {
          if (typeof field === 'string') {
            requiredFields.add(field);
          }
        });
      }

      Object.entries(properties).forEach(([key, schema]) => {
        const typedSchema = schema as {
          default?: unknown;
          type?: string;
          'ui:widget'?: string;
        };

        if (typedSchema['ui:widget'] === 'hidden') {
          hiddenFields.add(key);
        }

        // Set default values based on the schema type or default value (if we want to accelerate the filling of the form)
        if (typedSchema.default !== undefined) {
          parameterDefaults[key] = typedSchema.default;
          return;
        }

        parameterDefaults[key] = null;
      });
    });
  }

  const values: Record<string, unknown> = { ...parameterDefaults };

  return {
    values,
    requiredFields,
    hiddenFields,
  };
};
